import Base from "./Base";
import store from "../storeWire";
import {setProductDetail} from "../store/slice/model/ProductDetail";

class ProductDetail extends Base {
    setProductDetail(data) {
        this.data = data;
        store.dispatch(setProductDetail({
            data: this.data
        }));
    }
}

export default ProductDetail;